import { render, staticRenderFns } from "./trainingscores.vue?vue&type=template&id=5029706d&"
import script from "./trainingscores.vue?vue&type=script&lang=js&"
export * from "./trainingscores.vue?vue&type=script&lang=js&"
import style0 from "./trainingscores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports